export const navigationItems = [
  {
    id: "reports",
    text: "Reports",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="30"
        viewBox="0 0 28 30"
        fill="none"
      >
        <g clip-path="url(#clip0_5705_262)">
          <path
            d="M12.4333 11.0947C12.4333 10.5976 12.8363 10.1947 13.3333 10.1947H13.6667C14.1637 10.1947 14.5667 10.5976 14.5667 11.0947V22.7137C14.5667 23.2108 14.1637 23.6137 13.6667 23.6137H13.3333C12.8363 23.6137 12.4333 23.2108 12.4333 22.7137V11.0947ZM17.1 16.5423C17.1 16.0452 17.5029 15.6423 18 15.6423H18.3333C18.8304 15.6423 19.2333 16.0452 19.2333 16.5423V22.7137C19.2333 23.2108 18.8304 23.6137 18.3333 23.6137H18C17.5029 23.6137 17.1 23.2108 17.1 22.7137V16.5423ZM7.76667 19.2661C7.76667 18.7691 8.16961 18.3661 8.66667 18.3661H9C9.49706 18.3661 9.9 18.7691 9.9 19.2661V22.7137C9.9 23.2108 9.49706 23.6137 9 23.6137H8.66667C8.16961 23.6137 7.76667 23.2108 7.76667 22.7137V19.2661ZM17.1 7.00897C17.1 6.40145 16.6075 5.90897 16 5.90897H6.33333C5.72582 5.90897 5.23333 6.40145 5.23333 7.00897V26.7994C5.23333 27.407 5.72582 27.8994 6.33333 27.8994H20.6667C21.2742 27.8994 21.7667 27.407 21.7667 26.7994V12.4566C21.7667 11.8491 21.2742 11.3566 20.6667 11.3566H18C17.5029 11.3566 17.1 10.9536 17.1 10.4566V7.00897ZM3.1 4.63589C3.1 3.93077 3.59065 3.38516 4.16492 3.38516H17.7065C17.9694 3.38516 18.2191 3.50005 18.3901 3.69966L23.6832 9.87894C23.8229 10.042 23.8997 10.2497 23.8997 10.4644L23.9 29.1511C23.9 29.8701 23.4106 30.4233 22.841 30.4233H4.15897C3.5886 30.4233 3.1 29.8636 3.1 29.1725V4.63589Z"
            fill="white"
            stroke="black"
            stroke-width="0.2"
          />
        </g>
        <defs>
          <clipPath id="clip0_5705_262">
            <rect
              width="28"
              height="29.3333"
              fill="white"
              transform="translate(0 0.667969)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: "home",
    text: "Home",
    svg: (
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 9L12 2L21 9V20C21 20.55 20.55 21 20 21H4C3.45 21 3 20.55 3 20V9Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 20V12H15V20"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "screening",
    text: "Literature Review Tools",
    svg: (
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 2H20V22H6.5A2.5 2.5 0 0 1 4 19.5V4.5A2.5 2.5 0 0 1 6.5 2Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 6H16"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8 10H16"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8 14H16"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8 18H16"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    id: "scheduleRuns",
    text: "Schedule Runs",
    svg: (
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 2V6"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 2V6"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 10H21"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 16L14 14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 12V16"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "about",
    text: "About",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="white"
      >
        <path
          d="M3.12462 17.3095L6.56159 15.1142L6.56159 12.64L0.00679456 16.8039L0.00679442 18.3513L9.61843 23.4883L19.1001 17.6826L19.1001 14.8466L19.1001 10.4785L17.2091 11.5811L17.2091 15.8572L9.55483 20.5214L3.12462 17.3095Z"
          fill="white"
        />
        <path
          d="M15.9755 6.89757L12.6338 9.03043L12.6338 11.5117L19.0933 7.40317L19.0933 5.85572L9.48167 0.718752L-9.02997e-07 6.5244L-1.53263e-06 9.48635L1.89097 8.34983L9.54527 3.68559L15.9755 6.89757Z"
          fill="white"
        />
        <path
          d="M8.83447 10.377L8.83447 16.334L10.4507 16.334L10.4507 10.377L8.83447 10.377ZM9.63916 7.36914C9.38671 7.36914 9.16862 7.45772 8.99072 7.63379L8.92725 7.7002C8.78802 7.86137 8.71729 8.05407 8.71729 8.27344C8.71739 8.52132 8.80953 8.7361 8.98975 8.91211C9.16794 9.08588 9.3868 9.17285 9.63916 9.17285C9.88913 9.1728 10.1073 9.08606 10.2876 8.91309L10.2876 8.91211C10.4679 8.73607 10.56 8.52139 10.5601 8.27344C10.5601 8.0231 10.4686 7.80762 10.2876 7.63379L10.2183 7.57227C10.0524 7.43735 9.85836 7.36918 9.63916 7.36914Z"
          fill="white"
          stroke="white"
          stroke-width="0.2"
        />
      </svg>
    ),
  },
  {
    id: "disclaimer",
    text: "Disclaimer",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2L22 20H2L12 2Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 9V13"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17H12.01"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "login",
    text: "Log In | Sign Up",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
      >
        <path
          d="M3.12 5.8371V3.77207C3.12 3.22438 3.33627 2.69913 3.72123 2.31187C4.1062 1.9246 4.62833 1.70703 5.17275 1.70703H15.8471C16.3915 1.70703 16.9136 1.9246 17.2986 2.31187C17.6836 2.69913 17.8998 3.22438 17.8998 3.77207V16.1623C17.8998 16.71 17.6836 17.2352 17.2986 17.6225C16.9136 18.0097 16.3915 18.2273 15.8471 18.2273H5.17275C4.62833 18.2273 4.1062 18.0097 3.72123 17.6225C3.33627 17.2352 3.12 16.71 3.12 16.1623V14.0972"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.01031 14.0973L13.1164 9.9666L9.01031 5.83594"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 9.97266H11.9144"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "enterprise",
    text: "Enterprise",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M3 21H21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 21V7L13 2L21 7V21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 9V21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 9V21"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "help",
    text: "Help & FAQ",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g transform="translate(0, 2)">
          <path
            d="M9.5498 1C14.2765 1 18.0996 4.81173 18.0996 9.50293C18.0995 14.194 14.2764 18.0049 9.5498 18.0049C4.82326 18.0048 1.00015 14.1939 1 9.50293C1 4.81179 4.82317 1.00011 9.5498 1Z"
            stroke="white"
            stroke-width="2"
          />
          <path
            d="M8.644 11.9297V11.8004C8.64731 11.2005 8.70366 10.7232 8.81303 10.3686C8.92572 10.014 9.08481 9.72893 9.29031 9.51349C9.4958 9.29474 9.74603 9.09422 10.041 8.91193C10.2432 8.78598 10.4238 8.64844 10.5829 8.49929C10.7453 8.34683 10.8729 8.17779 10.9657 7.99219C11.0585 7.80327 11.1049 7.5928 11.1049 7.3608C11.1049 7.09896 11.0436 6.87192 10.921 6.67969C10.7984 6.48745 10.6326 6.33831 10.4238 6.23224C10.2183 6.12618 9.98799 6.07315 9.73278 6.07315C9.49746 6.07315 9.27373 6.12453 9.06161 6.22727C8.85281 6.3267 8.6788 6.47917 8.5396 6.68466C8.40371 6.88684 8.32747 7.1437 8.3109 7.45526H6.54102C6.55759 6.82552 6.71005 6.29853 6.9984 5.87429C7.29007 5.45005 7.67454 5.13187 8.15181 4.91974C8.6324 4.70762 9.1627 4.60156 9.74272 4.60156C10.3758 4.60156 10.9326 4.71259 11.4132 4.93466C11.8971 5.15672 12.2733 5.47325 12.5417 5.88423C12.8135 6.2919 12.9494 6.7758 12.9494 7.33594C12.9494 7.71378 12.8881 8.05185 12.7654 8.35014C12.6461 8.64844 12.4754 8.91359 12.2534 9.1456C12.0313 9.3776 11.7678 9.58475 11.4629 9.76705C11.1944 9.93277 10.974 10.1051 10.8017 10.2841C10.6326 10.4631 10.5067 10.6735 10.4238 10.9155C10.3443 11.1541 10.3029 11.4491 10.2995 11.8004V11.9297H8.644ZM9.50906 15.032C9.21076 15.032 8.95389 14.9259 8.73846 14.7138C8.52302 14.5017 8.41531 14.2431 8.41531 13.9382C8.41531 13.6399 8.52302 13.3847 8.73846 13.1726C8.95389 12.9605 9.21076 12.8544 9.50906 12.8544C9.80404 12.8544 10.0592 12.9605 10.2747 13.1726C10.4934 13.3847 10.6028 13.6399 10.6028 13.9382C10.6028 14.1404 10.5514 14.3243 10.4487 14.4901C10.3493 14.6558 10.2167 14.7884 10.051 14.8878C9.88855 14.9839 9.70792 15.032 9.50906 15.032Z"
            fill="white"
          />
        </g>
      </svg>
    ),
  },
  {
    id: "privacy",
    text: "Privacy",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M10 20.999L7.18762 18.9902C4.55966 17.1131 3 14.0824 3 10.8529L3 5.75335C3 5.30687 3.29598 4.91448 3.72528 4.79182L9.72528 3.07754C9.90483 3.02624 10.0952 3.02624 10.2747 3.07754L16.2747 4.79182C16.704 4.91448 17 5.30687 17 5.75335V7.49905M19 14.999V12.999C19 11.8945 18.1046 10.999 17 10.999C15.8954 10.999 15 11.8945 15 12.999V14.999M19 14.999H15M19 14.999C20.1046 14.999 21 15.8945 21 16.999V18.999C21 20.1036 20.1046 20.999 19 20.999H15C13.8954 20.999 13 20.1036 13 18.999V16.999C13 15.8945 13.8954 14.999 15 14.999" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    ),
  },
  {
    id: "logout",
    text: "Log Out",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
      >
        <path
          d="M15.7793 14.1004L15.7793 16.1654C15.7793 16.7131 15.563 17.2384 15.1781 17.6256C14.7931 18.0129 14.271 18.2305 13.7265 18.2305L3.05221 18.2305C2.50778 18.2305 1.98566 18.0129 1.60069 17.6256C1.21572 17.2384 0.999452 16.7131 0.999452 16.1654L0.999453 3.77523C0.999453 3.22755 1.21572 2.7023 1.60069 2.31503C1.98566 1.92776 2.50778 1.71019 3.05221 1.71019L13.7265 1.7102C14.271 1.7102 14.7931 1.92776 15.1781 2.31503C15.563 2.7023 15.7793 3.22755 15.7793 3.77523L15.7793 5.84026"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.88867 5.84025L5.78257 9.9709L9.88867 14.1016"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.8984 9.96484L6.98404 9.96484"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
];
